import { createStyles, Theme } from '@material-ui/core/styles';
import { UNIT, mainColor, BORDER_RADIUS } from '../../constants/theme';
export const styles = (theme: Theme) => createStyles({

    heading: {
        fontSize: UNIT * 0.9375,
        fontWeight: 'bolder',
        minWidth: UNIT * 12.5,
        color: mainColor.colorBlackLight
    },
    valueC: {
        fontSize: UNIT * 0.9375,
        flexBasis: '19%',
        flexShrink: 0,
        padding: UNIT * 1.0625,
        textAlign: 'center',
        color: 'black'
    },
    icon: {
        fontSize: UNIT * 1.5,

        backgroundColor: 'transparent',
        color: mainColor.colorBlack
    },
    itemStyle: {
        paddingBottom: 0,
        paddingTop: 0
    },
    title: {
        fontWeight: 600,
        color: 'black!important'
    },
    description: {
        fontSize: '12px'
    },
    configText: {
        color: mainColor.colorBlack,
        marginLeft: -UNIT
    },
    disabledItem: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#0000006E',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    typo: {
        fontSize: '15px',
        fontWeight: 'bolder'
    },
    disabledTypo: {
        fontSize: '15px',
        fontWeight: 'bolder',
        color: 'white!important',
        textAlign: 'center'
    },
    paddingStyle: { padding: '0px!important' },
    cardContent: {
        borderRadius: UNIT,
        cursor: 'pointer',
        position: 'relative',
        '@media screen and (min-width: 960px)': {
            height: '312px',
        }
    },
    titleStyle: {
        fontSize: UNIT * 0.875,
    },
    listStyle: {
        maxHeight: UNIT * 26.5,
        minHeight: UNIT * 6.25,
        overflow: 'auto'
    },
    flexContainer: {
        display: 'flex',
        alignItems: 'center',

    },
    connexionName: {
        textTransform: 'capitalize', fontSize: '12px'
    },
    groupHeader: {
        fontWeight: 'bold',
        flex: 1,
    },
    groupContent: {
        flexDirection: 'column',
        padding: 0,
    },
    shopList: {
        width: '100%',
    },
    grouStyle: {
        paddingBottom: 0,
        paddingTop: 0,
    },
    root: {
        '&:before': {
            height: 0
        },

    },
    expanded: {
        overflow: 'auto',
        height: '141px'
    },
    content: {
        margin: 0,
        '&$expanded': {
            margin: 0,
        },
    },
    listContainer: {
        maxHeight: '60vh',
        overflowY: 'auto',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
    },
    textStyle: {
        fontSize: UNIT * 0.75,
        color: '#a19c9c!important'
    },
    modalTitle: {
        fontSize: '1.25rem',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    modalDescription: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
    },
    section: {
        padding: '9px 0px',
    },
    sectionTitle: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    sectionDescription: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
    },
    dateRow: {
        marginBottom: theme.spacing(2),
    },
    footerText: {
        fontStyle: 'italic',
        color: theme.palette.text.secondary,
    },
    groupStyle: {
        padding: 0
    },
    responsiveContainer: {
        display: 'flex',
        height: '402px',
        flexDirection: 'row',
        '@media (max-width: 960px)': {
            flexDirection: 'column',
            height: 'auto'
        },
    },
    leftResponsiveContainer: {
        display: 'flex',
        flexDirection: 'row',
        '@media (max-width: 960px)': {
            flexDirection: 'column',
            overflow: 'auto'
        },
    },
    leftSection: {
        borderRight: '1px solid #e0e0e0',
        paddingRight: '17px',
        width: '442px',
        overflowX: 'hidden',
        '@media (max-width: 960px)': {
            width: '100%',
            borderRight: 'none',
            borderBottom: '1px solid #e0e0e0',
            paddingRight: '0',
            paddingBottom: '20px',
            marginBottom: '20px'
        },
    },
    rightDetailSection: {
        flex: 1,
        paddingLeft: '17px',
        width: '469px',
        overflowX: 'hidden',
        '@media (max-width: 960px)': {
            paddingLeft: '0',
            width: '100%'
        },
    },
    defaultListContainer: {
        height: '317px',
        overflow: 'auto',
        width: '-webkit-fill-available',
        '@media (max-width: 960px)': {
            height: 'auto',
            maxHeight: 'none',
            overflow: 'visible'
        }
    },
    defaultListContainerWithoutButton: {
        height: '356px',
        overflow: 'auto',
        width: '-webkit-fill-available',
        '@media (max-width: 960px)': {
            height: 'auto',
            maxHeight: '356px'
        }
    },
    productsListContainer: {
        height: '267px',
        overflow: 'auto',
        width: '-webkit-fill-available',
        '@media (max-width: 960px)': {
            height: 'auto',
            maxHeight: '300px'
        }
    },
    productsOffredListContainer: {
        height: '267px',
        overflow: 'auto',
        width: '-webkit-fill-available',
        '@media (max-width: 960px)': {
            height: 'auto',
            maxHeight: '300px'
        }
    },
    dividerStyle: {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        margin: 'revert'
    },
    buttonStyle: {
        '@media (max-width: 960px)': {
            width: '100%',
            marginTop: '20px !important'
        }
    },
    sectionName: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    paper: {
        padding: UNIT * 0.625,
        paddingTop: 0,
        borderRadius: UNIT,
        margin: UNIT * 0.625,
        position: 'relative',
        width: UNIT * 11.71875,
        maxHeight: UNIT * 25
    },
    modalHight: {
        height: 'auto',
        overflow: 'auto',
        '@media (min-width: 960px)': {
            height: '60vh',

        }
    },
    paperStyle: {
        borderRadius: BORDER_RADIUS,
        position: 'relative'
    },
    leftArrow: {
        marginLeft: 4,
        verticalAlign: 'middle'
    },
    card: {
        borderRadius: 8,
        height: '400px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': { boxShadow: '0px 4px 10px rgba(0,0,0,0.15)' },
        position: 'relative',
    },
    media: {
        width: '100%',
        height: 200,
        objectFit: 'cover',
        objectPosition: 'center',
    },
    campaignCardContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '16px',
    },
    campaignTitle: {
        fontWeight: 'bold',
        textAlign: 'left',
        color: `${mainColor.colorBlack}!important`,
        width: '100%',
    },
    campaignDescription: {
        color: `${mainColor.colorBlack}!important`,
        marginTop: 8,
        marginBottom: 16,
        textAlign: 'left',
        width: '100%',
        fontSize: '12px',
    },
    more: {
        fontWeight: 'bold',
        color: `${mainColor.secondaryColor}!important`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 'auto',
        cursor: 'pointer',
    },
    rightSection: {
        flex: 1,
        paddingLeft: '17px',
        width: '469px',
        overflowX: 'hidden',
        '@media (max-width: 960px)': {
            paddingLeft: '0',
            width: '100%'
        },
    },
});
